module.exports = __webpack_public_path__ + "assets/img/car17.1ace3fb6.jpg";